import axios from "../../../config/axiosConfig";

export const listarCuentasFlespi = () =>
  axios.get("/api/flespi/cuentas");

export const obtenerCuentaFlespiPorSlug = (slug) =>
  axios.get(`/api/flespi/cuentas/${encodeURIComponent(slug)}`);

export const listarTiposFlespi = (origen) =>
  axios.get("/api/flespi/tipos-dispositivo", { params: { origen } });

export const listarSubcuentasFlespi = (origen) =>
  axios.get("/api/flespi/subcuentas", { params: { origen } });

export const listarDispositivosFlespi = ({
  origen,
  tipo,
  page = 1,
  limit = 25,
  search = "",
  status = "",
  sortKey = "",
  sortDir = "asc",
}) =>
  axios.get("/api/flespi/dispositivos", {
    params: { origen, tipo, page, limit, search, status, sortKey, sortDir },
  });

export const obtenerDispositivoFlespi = (id, { origen, tipo }) =>
  axios.get(`/api/flespi/dispositivos/${id}`, { params: { origen, tipo } });

export const registrarDispositivosFlespi = (body) =>
  axios.post("/api/flespi/dispositivos", body);

export const validarDispositivosMasivosFlespi = (body) =>
  axios.post("/api/flespi/dispositivos/validar-masivo", body);

export const editarDispositivoFlespi = (id, body) =>
  axios.patch(`/api/flespi/dispositivos/${id}`, body);

export const cambiarEstadoDispositivosFlespi = (body) =>
  axios.post("/api/flespi/dispositivos/estado", body);

export const moverDispositivosFlespi = (body) =>
  axios.post("/api/flespi/dispositivos/mover-subcuenta", body);

export const eliminarDispositivosFlespi = (body) =>
  axios.delete("/api/flespi/dispositivos", { data: body });
